import {
    Box,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Stack,
    Skeleton,
    TablePagination,
} from "@mui/material";

export default function SkeletonListarNotas() {
    // Cria um array com 10 itens para simular as linhas da tabela
    const skeletonRows = Array.from({ length: 10 }, (_, index) => index);

    return (
        <Box sx={{ width: "100%", overflowX: "auto" }}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell sx={{ width: '25%' }}><b>DANFE</b></TableCell>
                        <TableCell><b>Emitente</b></TableCell>
                        <TableCell><b>Emissão</b></TableCell>
                        <TableCell align="right"><b>Valor</b></TableCell>
                        <TableCell><b>Status</b></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {skeletonRows.map((index) => (
                        <TableRow key={index} hover>
                            <TableCell>
                                <Stack gap={0.5}>
                                    <Skeleton variant="text" width="60%" height={24} />
                                    <Skeleton variant="text" width="80%" height={20} />
                                </Stack>
                            </TableCell>
                            <TableCell align="left">
                                <Skeleton variant="text" width="90%" height={24} />
                            </TableCell>
                            <TableCell align="left">
                                <Skeleton variant="text" width="70%" height={24} />
                            </TableCell>
                            <TableCell align="right">
                                <Skeleton variant="text" width="80%" height={24} />
                            </TableCell>
                            <TableCell>
                                <Skeleton variant="rectangular" width={80} height={24} sx={{ borderRadius: 1 }} />
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
            <Stack direction="row" justifyContent="flex-end">
                <TablePagination
                    component="div"
                    count={0}
                    page={0}
                    onPageChange={() => {}}
                    rowsPerPage={10}
                    onRowsPerPageChange={() => {}}
                    labelRowsPerPage="Linhas por página"
                />
            </Stack>
        </Box>
    );
}